/**
 * @generated SignedSource<<2ea65b3943d2f2e462a50f9d3e52dd68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfirmPanel_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ActionButton_Booking" | "BookingInfo_Booking" | "BookingPolicy_Booking" | "PaymentDisplay_Booking" | "PlayerList_Booking" | "YourRound_Booking">;
  readonly " $fragmentType": "ConfirmPanel_Booking";
};
export type ConfirmPanel_Booking$key = {
  readonly " $data"?: ConfirmPanel_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfirmPanel_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfirmPanel_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingInfo_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPolicy_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentDisplay_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlayerList_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActionButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "YourRound_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "d729cf6b0018f6dce42274e765f99d2c";

export default node;
